// extracted by mini-css-extract-plugin
module.exports = {"details":"styles_details__3RV7h","error":"styles_error__27aof","link":"styles_link__3I1D1"};